import moment from "moment";
import { BaseReq, FileRecord, PaginationReq, PaginationResp, UpdaterResp } from "@/core/interface";
import { getCurrentUserId } from "@/utils";

export enum CheckTabEnum {
  BASIC_TAB = "BASIC_TAB", // 基本信息
  ATTACHMENT_TAB = "ATTACHMENT_TAB", // 附件
  FLOW_TAB = "FLOW_TAB", // 流程
}

export class CheckReq extends BaseReq {
  projectId: string | undefined = undefined; // 项目ID
  checkDate: string = moment().format("YYYY-MM-DD"); // 检查日期
  checkTenantUserId: string = getCurrentUserId(); // 质检负责人
  acceptCheckTenantUserId: string | undefined = undefined; // 受检负责人
  isChange: boolean = false; // 是否需要整改
  checkRemark: string = ""; // 检查情况
  innerRemark: string = ""; // 内部备注
  imgUrl: string[] = []; // 现场图片
  fileList: FileRecord[];

}

export class CheckPageReq extends PaginationReq {
  bizNo: string | undefined = undefined; // 质检记录编号
  name: string | undefined = undefined; // 项目名称
  checkStartDate: string | undefined = undefined; // 检查结束日期
  checkFinishDate: string | undefined = undefined; // 检查开始日期
  isChange: boolean | undefined = undefined; // 是否整改
  isBeRelated: boolean | undefined = undefined; // 是否被关联
  checkTenantUserId: string | undefined = undefined; // 质检负责人
  flowStatus?: string = "";  // 状态
  skipProjectRight: number | undefined = undefined;
  addRightBizType: string | undefined = undefined;
  projectId: string | undefined = undefined; // 项目 ID
  firstDisplayProjectId: string | undefined = undefined; // 首次显示项目 ID
}

export class CheckListRecord extends UpdaterResp {
  id: string = ""; // 质量检查ID
  bizNo: string = ""; // 质量检查编号
  name: string = ""; // 项目名称
  checkDate: string = ""; // 检查日期
  checkTenantUserId: string = ""; // 质检负责人 ID
  tenantUserIdName: string = ""; // 质检负责人名称
  checkRemark: string = ""; // 检查记录
  isChange: boolean | undefined = undefined; // 是否整改
  flowStatusName: string = ""; // 审批状态
  lastModifiedTime: string = ""; // 更新时间
}

export class CheckPageResp extends PaginationResp<CheckListRecord> {}

class QualityChangeDto {
  qualityChangeId: string = "";
  qualityChangeBizNo: string = "";
}

export class CheckDetailResp extends UpdaterResp {
  id: string = ""; // 质量检查 ID
  projectId: string = ""; // 项目ID
  name: string = ""; // 项目名称
  checkDate: string = ""; // 检查日期
  checkTenantUserId: string = ""; // 质检负责人
  tenantUserIdName: string = ""; // 质检负责人
  acceptCheckTenantUserId: string = ""; // 受检负责人
  inspectedTenantUserIdName: string = ""; // 受检负责人
  isChange: boolean | undefined = undefined; // 是否整改
  qualityChangeDto: QualityChangeDto[] = [];
  checkRemark: string = ""; // 检查情况
  innerRemark: string = ""; // 内部备注
  imgUrl: string[] = []; // 现场图片
}

export class CheckSimpleListReq {
  acceptCheckTenantUserId: string | undefined = undefined; // 受检负责人
  checkDate: string | undefined = undefined; // 检查日期
  checkTenantUserId: string | undefined = undefined; // 质检负责人
  isChange: boolean | undefined = undefined; // 是否整改
  projectId: string | undefined = undefined; // 项目 ID
  ids: string[] | undefined = undefined;
}

class CheckSimpleRecord {
  id: string = "";
  bizNo: string = "";
}

export class CheckSimpleListResp {
  records: CheckSimpleRecord[] = [];
}
